import React from "react"
import THead from "./THead"
import TBody from "./TBody"
import PropTypes from "prop-types"
import "./Table.scss"
import { bem } from "../../helpers"

export const Table = (props) => {
  const {headers, body, className} = props
  return (
    <table className={bem("table", null, [], className)}>
      <THead headers={headers}/>
      <TBody body={body} headers={headers} />
    </table>
  )
}

Table.propTypes = {
  headers: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.exact({
      key: PropTypes.string.isRequired,
      data: PropTypes.string.isRequired,
      className: PropTypes.string
    })).isRequired,
    className: PropTypes.string
  }),
  body: PropTypes.shape({
    className: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.object)
  }).isRequired,
  className: PropTypes.string
}

Table.defaultProps = {

}

export default Table
